import { useEffect } from 'react';
import * as Cesium from 'cesium';
import tokenService from '../services/auth/tokenService';

/**
 * Custom hook to configure Cesium authentication headers
 * This ensures all Cesium HTTP requests include the JWT token
 */
export const useCesiumAuth = () => {
  useEffect(() => {
    const token = tokenService.getAccessToken();
    
    if (token) {
      const originalLoadWithXhr = Cesium.Resource._Implementations.loadWithXhr;
      
      Cesium.Resource._Implementations.loadWithXhr = function(url, responseType, method, data, headers, deferred, overrideMimeType) {
        const newHeaders = headers || {};
        
        // Only add the header to requests targeting our 3D model proxy
        if (typeof url === 'string' && url.includes('/api/3d-model-proxy/')) {
          newHeaders.Authorization = `Bearer ${token}`;
          console.log(`🔐 Adding auth header to Cesium request: ${url}`);
        }
        
        // Call the original function with the potentially modified headers
        return originalLoadWithXhr.call(this, url, responseType, method, data, newHeaders, deferred, overrideMimeType);
      };
      
      console.log('✅ Cesium authentication configured by overriding loadWithXhr.');
      
      // Cleanup function to restore the original implementation
      return () => {
        Cesium.Resource._Implementations.loadWithXhr = originalLoadWithXhr;
        console.log('🧹 Cesium authentication cleanup complete.');
      };
    }
  }, []);
};

export default useCesiumAuth; 